"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.symbol");
require("core-js/modules/es.array.concat");
require("core-js/modules/es.array.filter");
require("core-js/modules/es.array.for-each");
require("core-js/modules/es.object.define-properties");
require("core-js/modules/es.object.define-property");
require("core-js/modules/es.object.get-own-property-descriptor");
require("core-js/modules/es.object.get-own-property-descriptors");
require("core-js/modules/es.object.keys");
require("core-js/modules/es.object.to-string");
require("core-js/modules/es.promise");
require("core-js/modules/web.dom-collections.for-each");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMe = getMe;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function getMe() {
  return _getMe.apply(this, arguments);
}
function _getMe() {
  _getMe = (0, _asyncToGenerator2["default"])(/*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var initialHeaders,
      headers,
      res,
      me,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initialHeaders = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            headers = _objectSpread({}, initialHeaders, {
              Accept: 'application/json'
            });
            _context.next = 4;
            return fetch("".concat(this.url, "/me"), {
              method: 'GET',
              mode: 'cors',
              headers: headers,
              credentials: 'include' // Don't forget to specify this if you need cookies
            });
          case 4:
            res = _context.sent;
            if (res.ok) {
              _context.next = 7;
              break;
            }
            throw Error("".concat(res.status, ": ").concat(res.statusText));
          case 7:
            _context.next = 9;
            return res.json();
          case 9:
            me = _context.sent;
            if (!(!me || !me.user)) {
              _context.next = 12;
              break;
            }
            throw Error('unauthorized, no user or session found');
          case 12:
            return _context.abrupt("return", me);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _getMe.apply(this, arguments);
}